import { createContext } from 'preact';

/**
 * Provide a close handler to descendants. This can allow, e.g., button-like
 * components to correctly close a parent dialog or panel.
 */

const CloseableContext = createContext({});
export default CloseableContext;
//# sourceMappingURL=CloseableContext.js.map